<ng-container *ngLet="(authConfig$ | async) as authConfig">
    <section [formGroup]="formGroup">
        <mat-form-field>
            <ui-suggest [items]="timezones"
                        [clearable]="true"
                        [placeholder]="'settings_general_form_timezone' | translate"
                        [defaultValue]="'settings_general_form_timezone_empty' | translate"
                        [disabled]="isReadOnly$ | async"
                        [searchable]="true"
                        (selected)="settings.general.timezone = $event?.id"
                        formControlName="timezone"
                        data-cy="settings-general-timezone">
            </ui-suggest>
        </mat-form-field>

        <mat-form-field *ngIf="authConfig.application.isLocalizationEnabled">
            <ui-suggest [items]="languages"
                        [clearable]="true"
                        [placeholder]="'settings_general_form_language' | translate"
                        [defaultValue]="'settings_general_language_empty' | translate"
                        [disabled]="isReadOnly$ | async"
                        [disableTooltip]="true"
                        (selected)="settings.general.language = $event?.id"
                        formControlName="language"
                        class="settings-language-selector"
                        data-cy="settings-general-language">
            </ui-suggest>
        </mat-form-field>

        <mat-form-field *ngIf="showConnectionString">
            <input #connectionStringInput
                   [value]="connectionString$ | async"
                   [placeholder]="'settings_general_form_connection_string' | translate"
                   matInput
                   class="form-control connection-input"
                   readonly />
            <span matSuffix>
                <button [uiClipboard]="connectionStringInput"
                        [matTooltip]="'settings_general_form_connection_string_copy_tooltip' | translate"
                        (clipboardSuccess)="onClipboardCopy()"
                        mat-icon-button
                        type="button">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </span>
        </mat-form-field>
        <ng-container *ngLet="formGroup.get('isModernFolderSystemEnabled')! as modernFolderSystemControl">
            <div class="mat-checkbox-container mat-checkbox-with-warning">
                <mat-checkbox #toggleModernFolders
                              [disabled]="modernFolderSystemControl.pristine &&
                                      modernFolderSystemControl.value"
                              [uiClickTrack]="'Action: Modern Folders: ' +
                                          (toggleModernFolders.checked ? 'Dis' : 'En') + 'able'"
                              (change)="settings.general.isModernFolderSystemEnabled = $event.checked"
                              formControlName="isModernFolderSystemEnabled"
                              name="isModernFolderSystemEnabled"
                              class="form-control"
                              data-cy="modern-folder-checkbox">
                    {{ 'settings_general_modern_folder_system_enabled' | translate }}
                </mat-checkbox>
                <mat-error *ngIf="!!modernFolderSystemControl.value &&
                              !modernFolderSystemControl.pristine"
                           class="mat-checkbox-warning">
                    {{ 'settings_general_modern_folder_system_warning' | translate }}
                </mat-error>
            </div>

            <ui-folders-default-roles *ngIf="modernFolderSystemControl.pristine &&
                                      modernFolderSystemControl.value">
            </ui-folders-default-roles>
        </ng-container>
    </section>
</ng-container>
